var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRemove1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_147_69",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_147_69",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACsElEQVR4nO2au24TURCGDxTcXoAEIizOGAXOBFHQ0FHGMyZ0eQugTah4AyRuIk8EogpvAVUARQl2FXScRMJO4uza653J+v+kqew91n4e/Tu7Z0MAAAAAAAAAAFCMVuvpNY7yNpH8ZNKDciU/8rF5jYI/N79wlPflBQ9XInlnfR7euZRIfk0vWn/ntUJTeLz47EaK8imf2LRy2GkN/vioH58srV83E80kW9YiuLaSLSPNby4nkn17AVpXZ+/lc4Zoaqzo+YqORPo5WJEvEBz1QxWTAjutRLKTR07TiyEAAAAAQP1Yj2E8owresBbCEG0vCx1N9iIRHeSjgjeshTBE28tCR5O9SEQH+ajgDWshDNH2stDRZC8S0UE+KnjDWghDtL0sdDQdSYjST7G7kVq6MKjY3eCovdKCovZOriN9iKZDQVnIaBQ9iCKlZEft5WNG10lRNyGajkS3dOH03O+uMunf8yVLn9udtdPWWLm7dhOiabzoQrLHSM4sLz+/BdF0HB26OW6iOTNGzoiLoeggeQ3RVFzYCdmTHDNBBW9MPUrF8REwFCNlvovxTgtPDv+TP6+jk5vb0VS8s+vo5OaLpsllVy25+aKpvOxZSJ4P0VRc9qwkQ/QIEI3oqB5cDGvCeuI4BuMdFZGMG5ZzqaOTGbfgU4qOeKhktsNS2WNS7LBoLQ/+scNC9WxlYYeFxu+wVLY5ix0WHerILPv+ndXFXINcnfh1g9F18LrBwUWo4A1rIQzR9rLQ0WQvEtFBPip4w1oIQ7S9LHQ02YtEdJCPCt7gqLvWUrjqivoneINJvjVQ9NfgjZWor8zFULWVSF4Eb7TbnauJ5Htzulm2U1q/EjzysN1ZaoTsKNuP7nVvB88cdra+zPl2oS6QUXdTlC85Ltx2MgAAAAAAAAAAAEDwwT8tybPDOZGFUQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRemove1);
export default __webpack_public_path__ + "static/media/ic_remove (1).7f0955a47e4e5a30ab95785dafe51c94.svg";
export { ForwardRef as ReactComponent };